import React from "react";
import { Phone, HeartHandshake, Activity, Shield } from "lucide-react";

const heldSteps = [
  {
    letter: "H",
    word: "Hilfe rufen",
    text: "Der Notruf 112 ist der wichtigste Schritt. Kein Kind muss alles können — aber jeder kann anrufen.",
    icon: Phone,
    color: "bg-paula-red",
    accent: "text-paula-red",
  },
  {
    letter: "E",
    word: "Ermutigen & trösten",
    text: "Da sein. Zuhören. Beruhigen. Die wichtigste Erste Hilfe ist oft die menschliche Wärme.",
    icon: HeartHandshake,
    color: "bg-paula-yellow",
    accent: "text-paula-yellow",
  },
  {
    letter: "L",
    word: "Lebenswichtige Funktionen prüfen",
    text: "Atmet die Person? Ist sie ansprechbar? Paula zeigt kindgerecht, worauf es ankommt.",
    icon: Activity,
    color: "bg-paula-blue",
    accent: "text-paula-blue",
  },
  {
    letter: "D",
    word: "Decke unterlegen & zudecken",
    text: "Vor Kälte und hartem Boden schützen — eine einfache Geste mit großer Wirkung.",
    icon: Shield,
    color: "bg-paula-ink",
    accent: "text-paula-ink",
  },
];

export const HeldRule = () => {
  return (
    <section
      id="held"
      data-testid="held-section"
      className="relative py-24 sm:py-32 bg-paula-yellow-soft border-y border-paula-yellow/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-red mb-4">
            Das Herzstück des Buches
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-paula-ink leading-[1.05] tracking-tight">
            Die <span className="text-paula-red">HELD</span>-Regel.
          </h2>
          <p className="mt-6 text-paula-ink/75 text-lg leading-relaxed">
            Vier Buchstaben. Vier Schritte. Damit aus „Ich kann nichts tun" ein
            klares „Ich helfe!" wird — auch wenn man erst vier ist.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {heldSteps.map((s, i) => (
            <div
              key={s.letter}
              data-testid={`held-step-${s.letter.toLowerCase()}`}
              className="relative rounded-3xl bg-white border border-slate-200 p-7 flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <div
                  className={`w-16 h-16 rounded-2xl ${s.color} text-white grid place-items-center font-display font-black text-3xl`}
                >
                  {s.letter}
                </div>
                <s.icon className={`${s.accent}`} size={24} />
              </div>
              <div className="text-xs uppercase tracking-widest text-paula-muted">
                Schritt {i + 1}
              </div>
              <div className="font-display font-bold text-xl text-paula-ink mt-1 leading-snug">
                {s.word}
              </div>
              <p className="text-paula-muted text-sm mt-3 leading-relaxed flex-1">
                {s.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white border border-slate-200 text-sm text-paula-ink">
          <span className="font-display font-semibold">Übung macht den Lebensretter.</span>
          <span className="text-paula-muted">— aus dem Buch</span>
        </div>
      </div>
    </section>
  );
};

export default HeldRule;
